import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { LockIcon } from 'lucide-react';
import { useCan } from '../useCan';
import { btnSecondary } from './styles';
import { canSee, navItem } from '../adminNav';
import type { AdminSectionKey } from '../../data/adminSections';
import type { Permission } from '../../core/types/team';

/** De route volgt het menu: wie het onderdeel niet in het menu ziet, kan het adres ook niet openen. */
export function RequireNav({
  section,
  children
}: {
  section: AdminSectionKey;
  children: ReactNode;
}) {
  const {
    access
  } = useCan();
  const n = navItem(section);
  if (!n || canSee(n, access)) return <>{children}</>;
  return <NoAccess data-id="element-5160" data-mp="2yigo4p8zcu98" />;
}

/**
 * Alleen met deze bevoegdheid voor alles (niet alleen eigen rijen). Wie het adres toch opent,
 * krijgt een rustig scherm met de weg terug; het onderdeel mount niet en laadt dus niets. Gemak,
 * geen beveiliging: de server antwoordt 403.
 */
export function RequirePermission({
  p,
  children
}: {
  p: Permission;
  children: ReactNode;
}) {
  const {
    canAll
  } = useCan();
  if (canAll(p)) return <>{children}</>;
  return <NoAccess data-id="element-5161" data-mp="2kbwewqglpcea" />;
}
export function NoAccess() {
  return <section className="mx-auto flex max-w-md flex-col items-center py-16 text-center" aria-labelledby="no-access" data-id="element-5162" data-mp="2keilonvo3nvg">
      <span className="flex h-12 w-12 items-center justify-center rounded-full bg-white text-muted" aria-hidden="true" data-id="element-5163" data-mp="2td2wl2uzkt94">
        <LockIcon className="h-5 w-5" strokeWidth={1.5} data-id="element-5164" data-mp="2ycpcxl642pm5" />
      </span>
      <h1 id="no-access" className="mt-5 font-display text-[1.6rem] font-light text-ink" data-id="element-5165" data-mp="2yactf3kpg76z">
        Dit deel is alleen voor Sarah
      </h1>
      <p className="mt-2 text-[14px] leading-relaxed text-muted" data-id="element-5166" data-mp="381qq73l9uswf">Jij ziet je eigen afspraken, rondt ze af en rekent ze af. De rest van het beheer houdt Sarah bij.</p>
      <Link to="/be" className={`${btnSecondary} mt-6`} data-id="element-5167" data-mp="3h2owxtn3heip">
        Naar je overzicht
      </Link>
    </section>;
}